import React from 'react';

export const StickyAddBar = () => {
  return <div></div>;
};
